import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppdataService } from '../../../../service/appdata.service';
import { Category } from '../../../../interfaces/categoryInterface';

interface CatStructure { id: string, name: string, active: boolean }

@Component({
    selector: 'app-cat-selection',
    standalone: false,
    templateUrl: './cat-selection.component.html',
    styleUrl: './cat-selection.component.scss'
})
export class CatSelectionComponent implements OnInit {
    categories: Category[] = [];
    dataService = inject(AppdataService);


    selectedStack: string[] = [];
    catStructure: CatStructure[] = [];
    secondLevel: string[] = [];

    @Output() categorieSelection = new EventEmitter<string[]>();
    @Input() initialValues: string[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['initialValues']) {
            this.selectedStack = changes['initialValues'].currentValue;
        }
    }

    ngOnInit(): void {
        this.dataService.categories.subscribe(categories => {
            if (categories.length > 0) {
                this.categories = categories;
                this.catStructure = [];
                categories.forEach(category => {
                    if (category.parentId === null) {

                        this.catStructure.push({
                            id: category.id,
                            name: category.name,
                            active: false,
                        });
                    }
                });

            }
        });
    }

    setParentActive(id: string) {
        this.catStructure.forEach(category => {
            if (category.id === id) {
                category.active = true;
                this.secondLevel = this.categories.filter(c => c.parentId === category.id).map(c => c.id);
            } else {
                category.active = false;
            }
        });
    }

    deleteCategorie(id: string) {
        const index = this.selectedStack.indexOf(id);
        if (index !== -1) {
            this.selectedStack.splice(index, 1);
        }
        this.categorieSelection.emit(this.selectedStack);
    }

    selectCategorie(id: string) {
        const exist = this.selectedStack.includes(id);
        if (!exist) {
            this.selectedStack.push(id);
        } else {
            return;
        }
        this.categorieSelection.emit(this.selectedStack);
    }
}
